export enum DaySelector {
    MAX_DAYS_SELECTED = 31,
    MIN_DAYS_SELECTED = 1,
    MAX_YEAR_SELECTED = 365, 
}
